(function () {
  'use strict';

  var enabled = window.theme && window.theme.settings && window.theme.settings.enable_related_by_custom_id;
  if (!enabled) return;
  if (!document.body.classList.contains('template-product')) return;

  var siblingCacheByCustomId = {};
  var handleCustomIdCache = {};
  var earlyMergePromises = {};

  window.__lopDebugPdpStart = window.__lopDebugPdpStart || Date.now();

  function lopDbg(hypothesisId, location, message, data) {
    var payload = {
      sessionId: 'a77e3a',
      hypothesisId: hypothesisId,
      location: location,
      message: message,
      data: data || {},
      timestamp: Date.now(),
      runId: 'pdp-post-fix',
      context: 'pdp',
    };
    if (window.__lopDebugPdpStart) {
      payload.data.elapsedMs = Date.now() - window.__lopDebugPdpStart;
    }
    window.__lopDebugLogs = window.__lopDebugLogs || [];
    window.__lopDebugLogs.push(payload);
    // #region agent log
    fetch('http://127.0.0.1:7671/ingest/0e3f593b-3921-4c66-ba3a-c3e43db960d9', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Debug-Session-Id': 'a77e3a' },
      body: JSON.stringify(payload),
    }).catch(function () {});
    // #endregion
  }

  function escapeAttr(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function normalizeTitle(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function cleanProductUrl(url) {
    if (!url) return '';
    return url.split('?')[0];
  }

  function getVariantImageSize(container) {
    if (container.classList.contains('product-related-by-id--xlarge')) return '160';
    if (container.classList.contains('product-related-by-id--large')) return '120';
    return '84';
  }

  function resizeImageUrl(url, width) {
    if (!url) return '';
    if (url.indexOf('width=') !== -1) {
      return url.replace(/width=\d+/, 'width=' + width);
    }
    var joiner = url.indexOf('?') === -1 ? '?' : '&';
    return url + joiner + 'width=' + width;
  }

  function dedupeByHandle(items) {
    var seen = {};
    return items.filter(function (item) {
      if (!item.handle || seen[item.handle]) return false;
      seen[item.handle] = true;
      return Boolean(item.url && item.image);
    });
  }

  function cacheSiblings(customId, items) {
    if (!customId || !items || items.length < 2) return;
    siblingCacheByCustomId[customId] = items;
  }

  function fetchCustomIdForHandle(handle) {
    if (Object.prototype.hasOwnProperty.call(handleCustomIdCache, handle)) {
      return Promise.resolve(handleCustomIdCache[handle]);
    }

    var root = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    return fetch(root + 'products/' + encodeURIComponent(handle) + '?view=lop-custom-id', {
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('custom-id view failed');
        return response.text();
      })
      .then(function (text) {
        var data = JSON.parse(text);
        var customId = String(data.customId || '');
        handleCustomIdCache[handle] = customId;
        return customId;
      })
      .catch(function () {
        handleCustomIdCache[handle] = '';
        return '';
      });
  }

  function filterItemsByCustomId(items, expectedCustomId) {
    if (!items.length || !expectedCustomId) return Promise.resolve([]);

    return Promise.all(
      items.map(function (item) {
        return fetchCustomIdForHandle(item.handle).then(function (id) {
          return id === expectedCustomId ? item : null;
        });
      })
    ).then(function (results) {
      return results.filter(Boolean);
    });
  }

  function fetchSuggestProducts(searchTitle) {
    var root = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    var url =
      root +
      'search/suggest.json?q=' +
      encodeURIComponent(searchTitle) +
      '&resources[type]=product&resources[limit]=10';

    function requestSuggest() {
      return fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('suggest failed');
        return response.json();
      });
    }

    if (window.__lopRelatedPrefetch && window.__lopRelatedPrefetchTitle === searchTitle) {
      lopDbg('P-B', 'lop-pdp-related-fill.js:fetchSuggestProducts', 'using liquid prefetch promise', {
        searchTitle: searchTitle,
      });
      return window.__lopRelatedPrefetch.then(function (data) {
        return data || requestSuggest();
      });
    }

    lopDbg('P-B', 'lop-pdp-related-fill.js:fetchSuggestProducts', 'cold suggest network', {
      searchTitle: searchTitle,
    });
    return requestSuggest();
  }

  function parseSuggestProducts(data, searchTitle) {
    var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    var targetTitle = normalizeTitle(searchTitle);

    return products
      .filter(function (product) {
        return normalizeTitle(product.title) === targetTitle;
      })
      .map(function (product) {
        var image = product.image || (product.featured_image && product.featured_image.url) || '';
        return {
          handle: product.handle,
          url: cleanProductUrl(product.url),
          title: product.title,
          image: image,
        };
      });
  }

  function readCurrentSwatchItems(container) {
    var items = [];

    container.querySelectorAll('.product-related-by-id__swatch').forEach(function (swatch) {
      var img = swatch.querySelector('img');
      var href = swatch.getAttribute('href') || swatch.href || '';
      var handle = href.split('/products/').pop().split('?')[0];

      items.push({
        handle: handle,
        url: href,
        title: swatch.getAttribute('title') || '',
        image: img ? img.getAttribute('src') : '',
      });
    });

    return dedupeByHandle(items);
  }

  function mergeSuggestData(data, searchTitle, customId, currentItems) {
    var searchItems = parseSuggestProducts(data, searchTitle);
    var knownHandles = {};

    currentItems.forEach(function (item) {
      knownHandles[item.handle] = true;
    });

    var candidates = searchItems.filter(function (item) {
      return !knownHandles[item.handle];
    });

    preloadSwatchImages(candidates);

    return filterItemsByCustomId(candidates, customId).then(function (validatedNew) {
      return dedupeByHandle(currentItems.concat(validatedNew));
    });
  }

  function fetchMergedItems(container, customId, searchTitle, currentItems) {
    if (earlyMergePromises[customId]) {
      return earlyMergePromises[customId];
    }

    return fetchSuggestProducts(searchTitle).then(function (data) {
      if (!data) return dedupeByHandle(currentItems);
      return mergeSuggestData(data, searchTitle, customId, currentItems);
    });
  }

  function registerEarlyMerge(container) {
    var customId = container.getAttribute('data-custom-id');
    var searchTitle = container.getAttribute('data-product-title');

    if (!customId || !searchTitle || earlyMergePromises[customId]) return;
    if (!window.__lopRelatedPrefetch || window.__lopRelatedPrefetchTitle !== searchTitle) return;

    earlyMergePromises[customId] = window.__lopRelatedPrefetch.then(function (data) {
      if (!data) return null;
      var currentItems = readCurrentSwatchItems(container);
      return mergeSuggestData(data, searchTitle, customId, currentItems);
    });
  }

  function buildSwatchHtml(item, activeHandle, imageSize) {
    if (!item.url || !item.image) return '';

    var isActive = item.handle === activeHandle;
    return (
      '<a href="' +
      escapeAttr(item.url) +
      '" class="product-related-by-id__swatch' +
      (isActive ? ' product-related-by-id__swatch--active' : '') +
      '" title="' +
      escapeAttr(item.title) +
      '">' +
      '<img src="' +
      escapeAttr(resizeImageUrl(item.image, imageSize)) +
      '" alt="' +
      escapeAttr(item.title) +
      '" loading="lazy" width="' +
      imageSize +
      '" height="' +
      imageSize +
      '">' +
      '</a>'
    );
  }

  function preloadSwatchImages(items) {
    items.forEach(function (item) {
      if (!item.image) return;
      var img = new Image();
      img.src = item.image;
    });
  }

  function appendMissingSwatches(container, newItems, activeHandle, meta) {
    var swatchesEl = container.querySelector('.product-related-by-id__swatches');
    if (!swatchesEl || !newItems.length) return;

    var beforeCount = swatchesEl.querySelectorAll('.product-related-by-id__swatch').length;
    var imageSize = getVariantImageSize(container);
    var existingHandles = {};

    readCurrentSwatchItems(container).forEach(function (item) {
      existingHandles[item.handle] = true;
    });

    preloadSwatchImages(newItems);

    newItems.forEach(function (item) {
      if (existingHandles[item.handle]) return;
      var html = buildSwatchHtml(item, activeHandle, imageSize);
      if (!html) return;
      existingHandles[item.handle] = true;
      swatchesEl.insertAdjacentHTML('beforeend', html);
    });

    container.setAttribute('data-related-filled', 'true');

    lopDbg('P-D', 'lop-pdp-related-fill.js:appendMissingSwatches', 'swatches appended', {
      source: meta && meta.source ? meta.source : 'unknown',
      beforeCount: beforeCount,
      afterCount: swatchesEl.querySelectorAll('.product-related-by-id__swatch').length,
      newHandles: newItems.map(function (i) {
        return i.handle;
      }),
      totalMs: meta && meta.totalMs != null ? meta.totalMs : null,
    });

    document.dispatchEvent(new CustomEvent('lop-pdp-related-fill:updated', { bubbles: true }));
  }

  function applySwatchFill(container, merged, activeHandle, currentItems, meta) {
    var newItems = merged.filter(function (item) {
      return !currentItems.some(function (existing) {
        return existing.handle === item.handle;
      });
    });

    if (currentItems.length >= 2 && newItems.length > 0) {
      appendMissingSwatches(container, newItems, activeHandle, meta);
      cacheSiblings(container.getAttribute('data-custom-id'), merged);
      return;
    }

    buildSwatches(container, merged, activeHandle, meta);
  }

  function buildSwatches(container, items, activeHandle, meta) {
    var swatchesEl = container.querySelector('.product-related-by-id__swatches');
    if (!swatchesEl || !items.length) return;

    var beforeCount = swatchesEl.querySelectorAll('.product-related-by-id__swatch').length;
    var imageSize = getVariantImageSize(container);
    var html = '';

    items.forEach(function (item) {
      html += buildSwatchHtml(item, activeHandle, imageSize);
    });

    swatchesEl.innerHTML = html;
    container.setAttribute('data-related-filled', 'true');
    cacheSiblings(container.getAttribute('data-custom-id'), items);

    lopDbg('P-D', 'lop-pdp-related-fill.js:buildSwatches', 'swatches rendered', {
      source: meta && meta.source ? meta.source : 'unknown',
      beforeCount: beforeCount,
      afterCount: items.length,
      handles: items.map(function (i) {
        return i.handle;
      }),
      totalMs: meta && meta.totalMs != null ? meta.totalMs : null,
    });

    document.dispatchEvent(new CustomEvent('lop-pdp-related-fill:updated', { bubbles: true }));
  }

  function fillContainer(container, initSource) {
    var customId = container.getAttribute('data-custom-id');
    var searchTitle = container.getAttribute('data-product-title');
    var activeHandle = container.getAttribute('data-product-handle');

    if (!customId || !searchTitle || !activeHandle) return;

    var currentItems = readCurrentSwatchItems(container);
    var cached = siblingCacheByCustomId[customId] || null;
    var hasLiquidPrefetch = Boolean(
      window.__lopRelatedPrefetch && window.__lopRelatedPrefetchTitle === searchTitle
    );
    var fillStart = Date.now();

    if (container.getAttribute('data-related-filled') === 'true') {
      var cachedComplete = cached && currentItems.length >= cached.length;
      if (cachedComplete || currentItems.length >= 3) {
        return;
      }
    }

    lopDbg('P-A', 'lop-pdp-related-fill.js:fillContainer', 'fill start', {
      initSource: initSource || 'unknown',
      customId: customId,
      activeHandle: activeHandle,
      liquidCount: currentItems.length,
      liquidHandles: currentItems.map(function (i) {
        return i.handle;
      }),
      hasLiquidPrefetch: hasLiquidPrefetch,
      hasSiblingCache: Boolean(cached && cached.length > currentItems.length),
      cacheCount: cached ? cached.length : 0,
    });

    if (cached && cached.length > currentItems.length) {
      applySwatchFill(container, cached, activeHandle, currentItems, {
        source: 'siblingCache',
        totalMs: Date.now() - fillStart,
      });
      return;
    }

    fetchMergedItems(container, customId, searchTitle, currentItems)
      .then(function (merged) {
        if (!merged) return null;

        var suggestMs = Date.now() - fillStart;
        lopDbg('P-C', 'lop-pdp-related-fill.js:fillContainer', 'merge resolved', {
          suggestMs: suggestMs,
          mergedCount: merged.length,
          mergedHandles: merged.map(function (i) {
            return i.handle;
          }),
        });

        return merged;
      })
      .then(function (merged) {
        if (!merged) return;

        var totalMs = Date.now() - fillStart;
        var liveCount = readCurrentSwatchItems(container).length;

        if (merged.length <= liveCount) {
          lopDbg('P-A', 'lop-pdp-related-fill.js:fillContainer', 'fill noop', {
            totalMs: totalMs,
            mergedCount: merged.length,
            liveCount: liveCount,
          });
          if (merged.length >= 2) {
            cacheSiblings(customId, merged);
            container.setAttribute('data-related-filled', 'true');
            document.dispatchEvent(new CustomEvent('lop-pdp-related-fill:updated', { bubbles: true }));
          }
          return;
        }

        applySwatchFill(container, merged, activeHandle, currentItems, {
          source: 'suggest',
          totalMs: totalMs,
        });
      })
      .catch(function () {
        lopDbg('P-E', 'lop-pdp-related-fill.js:fillContainer', 'fill error', {
          totalMs: Date.now() - fillStart,
          liquidCount: currentItems.length,
        });
        if (currentItems.length >= 2) {
          cacheSiblings(customId, currentItems);
          container.setAttribute('data-related-filled', 'true');
        }
      });
  }

  function init(initSource) {
    lopDbg('P-E', 'lop-pdp-related-fill.js:init', 'init called', {
      initSource: initSource || 'unknown',
    });

    if (initSource === 'color-swap') {
      earlyMergePromises = {};
    }

    document.querySelectorAll('.product-related-by-id[data-custom-id]').forEach(function (container) {
      if (initSource === 'color-swap') {
        container.removeAttribute('data-related-filled');
        registerEarlyMerge(container);
      }
      fillContainer(container, initSource);
    });
  }

  window.LopPdpRelatedFill = { init: init };

  document.querySelectorAll('.product-related-by-id[data-custom-id]').forEach(registerEarlyMerge);
  init('initial');

  document.addEventListener('lop-pdp-color-swap:complete', function () {
    init('color-swap');
  });
})();
